import { Component, Input, Renderer2 } from '@angular/core';
import { Produto } from '../../Interfaces/produtos';
import { ConnectionService } from '../../services/Connection/connection.service';
import { CacheService } from '../../services/Cache/cache.service';
import { Router } from '@angular/router';
import { EventsService } from '../../services/events/events.service';
import { typeInterface } from '../../Interfaces/company';

@Component({
  selector: 'app-product-menu',
  templateUrl: './product-menu.component.html',
  styleUrl: './product-menu.component.css'
})
export class ProductMenuComponent {
  @Input() product!: Produto;
  @Input() indexSection!: number;
  @Input() typeParam!: typeInterface;
  imgLoadead: boolean = false;
  

  constructor(
    private connection: ConnectionService,
    private cacheService: CacheService,
    private router: Router,
    private eventService: EventsService,
    private renderer: Renderer2,
  ){
      this.connection.nameCompany$.subscribe((newNameCompany: string) => {
        this.nameCompany = newNameCompany;
      });
  }

  nameCompany: string = '';

  capturaId(id: number, indexSection: number, product: any){
    if(this.nameCompany == '')
    {
      this.connection.nameCompany$.subscribe({
        next: (newNameCompany: string) => {
          console.log('Novo nome da empresa recebido:', newNameCompany);
        },
        error: (error) => {
          console.error('Erro ao receber nome da empresa:', error);
        },
        complete: () => {
          console.log('Completado');
        }
      });

      if(this.nameCompany == '')
      {
        this.nameCompany = this.cacheService.getItemLocal('name_cache_key')
      }
    }

    this.eventService.eventFilterSubject.next(true);
    this.router.navigate([this.nameCompany, 'product-detail', id])

  }


  //Quando as imagens dos produtos são carregadas
  loadImgComplete(event: Event){
    const element = event.target as HTMLImageElement;

    this.imgLoadead = true;
    this.renderer.addClass(element, 'complete')
  }

}
